import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "src/router/RoutersCst";

import Badge from "@pages/Contents/BadgeAndCertificates/Badge";
import BadgeAndCertificates from "@pages/Contents/Corporate/BadgeAndCertificates";
import AddBadge from "@pages/Contents/BadgeAndCertificates/Badge/AddBadge";
import EditBadge from "@pages/Contents/BadgeAndCertificates/Badge/EditBadge";
import Certificates from "@pages/Contents/BadgeAndCertificates/Certificates";
import AddCertificates from "@pages/Contents/BadgeAndCertificates/Certificates/AddCertificates";
import EditCertificates from "@pages/Contents/BadgeAndCertificates/Certificates/EditCertificates";
import SkillBook from "@pages/Contents/BadgeAndCertificates/SkillBook";
import AddSkillBook from "@pages/Contents/BadgeAndCertificates/SkillBook/Completions/AddSkillBook";
import { SkillBookStateProvider } from "@pages/Contents/BadgeAndCertificates/context/SkillBookContext";
import ManageRequests from "@pages/Contents/BadgeAndCertificates/SkillBook/Completions/ManageRequests";
import SkillBookEnrollments from "@pages/Contents/BadgeAndCertificates/SkillBook/Enrollments";
import SkillBookCompletions from "@pages/Contents/BadgeAndCertificates/SkillBook/Completions";
import ManageRequestsNew from "@pages/Contents/BadgeAndCertificates/SkillBook/Enrollments/ManageRequestsNew";
import AddSkillBookNew from "@pages/Contents/BadgeAndCertificates/SkillBook/Enrollments/AddSkillBookNew";
import { PagesID } from "@utils/utilsConfigurations";
import CustomFieldsForm from "@pages/Contents/Corporate/BadgeAndCertificates/CustomFieldsForm";
import React from "react";

const useCorporateBadgeCertificate = () => {
  const { isInclude } = useIsInclude();

  return {
    path: "badge-certificates",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("corporate&&badge-certificates")}
          >
            <BadgeAndCertificates />
          </ProtectedRoute>
        ),
      },
      {
        path: "certificates",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.certificate.template.read",
                )}
              >
                <Certificates />
              </ProtectedRoute>
            ),
          },
          {
            path: "add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.certificate.template.write",
                )}
              >
                <AddCertificates />
              </ProtectedRoute>
            ),
          },
          {
            path: "edit/:idCertificate",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.certificate.template.write",
                )}
              >
                <EditCertificates />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "badges",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.badge.template.read",
                )}
              >
                <Badge />
              </ProtectedRoute>
            ),
          },
          {
            path: "add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.badge.template.write",
                )}
              >
                <AddBadge />
              </ProtectedRoute>
            ),
          },
          {
            path: "edit/:idBadge",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.badge.template.write",
                )}
              >
                <EditBadge />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "skillBook",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("fe.external.certificate.read")}
              >
                <SkillBook />
              </ProtectedRoute>
            ),
          },
          {
            path: "enrollments",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("fe.external.certificate.write")}
              >
                <SkillBookEnrollments />
              </ProtectedRoute>
            ),
          },
          {
            path: "completions",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("fe.external.certificate.write")}
              >
                <SkillBookCompletions />
              </ProtectedRoute>
            ),
          },
          {
            path: "completions/add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("fe.external.certificate.write")}
              >
                <SkillBookStateProvider>
                  <AddSkillBook />
                </SkillBookStateProvider>
              </ProtectedRoute>
            ),
          },
          {
            path: "completions/manage-requests",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("fe.external.certificate.write")}
              >
                <ManageRequests />
              </ProtectedRoute>
            ),
          },
          {
            path: "completions/:userId/manage-requests",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("fe.external.certificate.write")}
              >
                <ManageRequests />
              </ProtectedRoute>
            ),
          },
          {
            path: "enrollments/add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("fe.external.certificate.write")}
              >
                <SkillBookStateProvider>
                  <AddSkillBookNew />
                </SkillBookStateProvider>
              </ProtectedRoute>
            ),
          },
          {
            path: "enrollments/manage-requests",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("fe.external.certificate.write")}
              >
                <ManageRequestsNew />
              </ProtectedRoute>
            ),
          },
          {
            path: "enrollments/:userId/manage-requests",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("fe.external.certificate.write")}
              >
                <ManageRequestsNew />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "skillbook-custom-fields",
        loader: () => ({
          title: PagesID["corporate.customFields"],
        }),
        element: (
          <ProtectedRoute isAllowed={isInclude("external.customfields.read")}>
            <CustomFieldsForm />
          </ProtectedRoute>
        ),
      },
    ],
  };
};

export default useCorporateBadgeCertificate;
